import { effect, inject, Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { LegalAcceptanceDialogComponent } from '@components';
import { LegalUrl } from '@interfaces';
import { httpsCallable } from 'firebase/functions';
import { RemoteConfigService, UserState } from 'moddy/common';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
    providedIn: 'root'
})
export class LegalService {
    public get url(): LegalUrl {
        return this._url;
    }

    private readonly user = inject(UserState).value;
    private readonly remoteConfigService = inject(RemoteConfigService);
    private readonly dialogService = inject(DialogService);
    private readonly functions = inject(Functions);
    private readonly acceptTermsAndPoliciesFn = httpsCallable(
        this.functions,
        'acceptTermsAndPolicies'
    );

    private dialogRef: DynamicDialogRef | null = null;

    private _url: LegalUrl;

    constructor() {
        const legalUrlAsString = this.remoteConfigService.getItem('legalUrl').asString();
        this._url = JSON.parse(legalUrlAsString);

        effect(() => this.initModalIfNeeded());
    }

    public initModalIfNeeded(): void {
        if (!this.user() || this.user()?.termsAndPoliciesAccepted) {
            this.dialogRef?.close();

            this.dialogRef = null;

            return;
        }

        this.dialogRef = this.dialogService.open(LegalAcceptanceDialogComponent, {
            modal: true,
            closable: false,
            closeOnEscape: false,
            header: 'Accept Terms and Policies',
            style: {
                maxWidth: '550px'
            }
        });
    }

    public acceptTermsAndPolicies(): Promise<unknown> {
        return this.acceptTermsAndPoliciesFn();
    }
}
